function buildGuard(mode) {
    return function (parent, settings) {
        return settings.mode === mode;
    };
}
export var isInitParent = buildGuard('init');
export var isOnBootParent = buildGuard('onBoot');
export var isRenderPageParent = buildGuard('renderPage');
export var isRenderConfigScreenParent = buildGuard('renderConfigScreen');
export var isRenderModalParent = buildGuard('renderModal');
export var isRenderSidebarPaneParent = buildGuard('renderItemFormSidebarPanel');
export var isRenderFieldExtensionParent = buildGuard('renderFieldExtension');
export var isRenderManualFieldExtensionConfigScreenParent = buildGuard('renderManualFieldExtensionConfigScreen');
//# sourceMappingURL=guards.js.map